import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=f579a514&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Service.vue?vue&type=style&index=1&id=f579a514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f579a514",
  null
  
)

export default component.exports